import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// items: [{ label, to? }]. The last item is the current page and is never a link.
export default function Breadcrumbs({ items, className = '' }) {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-1 text-small text-graphite">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1 min-w-0">
              {item.to && !isLast ? (
                <Link to={item.to} className="text-signal hover:underline truncate">
                  {item.label}
                </Link>
              ) : (
                <span className={`truncate ${isLast ? 'text-ink' : ''}`} aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <ChevronRight size={13} className="shrink-0" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
